import React, {useEffect, useState} from "react";
import {useParams} from "react-router";
import Card from "react-bootstrap/Card";
import PlayerFetch from "../PlayerFetch";
import Table from "react-bootstrap/Table";
import Image from "react-bootstrap/Image";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import {FaCloudDownloadAlt, FaWaveSquare, FaListAlt} from "react-icons/fa";
import {FaExternalLinkAlt} from "react-icons/fa";
import Spinner from "react-bootstrap/Spinner";

function SoundPage(props) {

    let params = useParams();

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [item, setItem] = useState({});
    const [image, setImage] = useState({});

    // Note: the empty deps array [] means
    // this useEffect will run once
    // similar to componentDidMount()
    useEffect(() => {
        fetch('https://freesound.org/apiv2/sounds/' + params.id + '/?&token=' + global.KEY)
            .then(res => res.json())
            .then(
                (result) => {
                    setIsLoaded(true);
                    setItem(result);
                    setImage(result.images);
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
    }, [params.id])

    if (error) {
        return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
        return <div><Spinner animation="border"/> Loading...</div>;
    } else {

        return (
            <div className="SoundPage">

                <Card>
                    <Card.Body>
                        <Card.Title><h2> {item.name}</h2></Card.Title>
                        <Card.Subtitle className="mb-2 text-muted">{item.created}</Card.Subtitle>
                        <Card.Img variant="top" src={image.waveform_l} alt="Audio wave form"/>
                        <Card.Text>
                            <p></p>
                            {item.description}
                        </Card.Text>
                        <Card.Text>
                            <PlayerFetch id={params.id}/>
                            <div className="container mt-2">
                                <div className="row">
                                    <div className="col text-center">
                                        <span><a href={item.download}><FaCloudDownloadAlt/>  Download file</a></span>
                                    </div>
                                    <div className="col text-center">
                                        <span><a href={item.url} target="_blank"
                                                 rel="noopener noreferrer"><FaExternalLinkAlt/>  Listen at FreeSound</a></span>
                                    </div>
                                </div>
                            </div>
                        </Card.Text>
                    </Card.Body>
                </Card>

                <div className="mb-4 mt-4">
                    <Accordion defaultActiveKey="0">
                        <Card>
                            <Card.Header>
                                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                    <h4><span className="align-text-top"><FaListAlt/></span> File Specifications</h4>
                                </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="0">
                                <Card.Body>
                                    <Table striped bordered hover>
                                        <thead>
                                        <tr>
                                            <th>Parameter</th>
                                            <th>Value</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>Type</td>
                                            <td>{item.type}</td>
                                        </tr>
                                        <tr>
                                            <td>Channels</td>
                                            <td>{item.channels}</td>
                                        </tr>
                                        <tr>
                                            <td>Filesize</td>
                                            <td>{item.filesize} bites</td>
                                        </tr>
                                        <tr>
                                            <td>Duration</td>
                                            <td>{item.duration} sec</td>
                                        </tr>
                                        <tr>
                                            <td>Bitrate</td>
                                            <td>{item.bitrate} bps</td>
                                        </tr>
                                        <tr>
                                            <td>Samplerate</td>
                                            <td>{item.samplerate} Hz</td>
                                        </tr>
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card>
                            <Card.Header>
                                <Accordion.Toggle as={Button} variant="link" eventKey="1">
                                    <h4><span className="align-text-top"><FaWaveSquare/></span> File Spectral</h4>
                                </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="1">
                                <Card.Body>
                                    <Image src={image.spectral_l} alt="Audio spectrum" fluid/>
                                    <p className="mt-2 text-muted">
                                        <em>License: <a href={item.license} target="_blank"
                                                        rel="noopener noreferrer">{item.license}</a>
                                        </em></p>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                </div>
            </div>
        );
    }
}

export default SoundPage;